import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Header() {
  return <>
      {/* Screen Header - Hidden on Print */}
      <header className="bg-gradient-to-br from-amber-100 via-orange-100 to-amber-100 border-b-4 border-amber-600 shadow-lg print:hidden" data-id="element-652">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-653">
          {/* Institute Header Image */}
          <div className="py-4" data-id="element-654">
            <img src="https://cdn.magicpatterns.com/uploads/tKsvB2aghjpxRbUKhgRsjp/image.png" alt="Aatmshakti Institute of Integrated Medical Research" className="w-full h-auto max-w-5xl mx-auto" data-id="element-655" />
          </div>

          {/* Form Title with TCM styling */}
          <div className="py-6 border-t-2 border-amber-300" data-id="element-656">
            <div className="text-center" data-id="element-657">
              <div className="inline-block" data-id="element-658">
                <h1 className="text-2xl md:text-3xl font-bold text-amber-900 tracking-wide" data-id="element-659">
                  Patient Registration & Examination Form
                </h1>
                <div className="h-1 bg-gradient-to-r from-transparent via-amber-600 to-transparent mt-2" data-id="element-660"></div>
                <p className="text-amber-700 text-sm mt-2 font-medium" data-id="element-661">
                  Traditional Chinese Medicine & Acupuncture Assessment
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Print Header - Only Visible on Print */}
      <div className="hidden print:block border-b-4 border-amber-800 pb-4 mb-6 bg-white" data-id="element-662">
        <img src="https://cdn.magicpatterns.com/uploads/tKsvB2aghjpxRbUKhgRsjp/image.png" alt="Aatmshakti Institute" className="w-full h-auto mb-4" data-id="element-663" />
        <div className="text-center border-t-2 border-amber-300 pt-3" data-id="element-664">
          <h2 className="text-xl font-bold text-amber-900" data-id="element-665">
            Patient Registration & Examination Form
          </h2>
          <p className="text-sm text-amber-700 mt-1" data-id="element-666">
            Traditional Chinese Medicine & Acupuncture Assessment
          </p>
        </div>
      </div>
    </>;
}